
    <div class="content">
      <div class="restricted-region-column">
        <h2 translate class="_10-px-margin">Welcome to Edgeless</h2>
        <p class="paragraph">
          Unfortunately, you are trying to register from restricted country.<br />
          Edgeless real money games is currently not available in
          {{ countryRestrictionService.userCountry || 'Dark Web' }}.
        </p>
        <div class="_20-px-spacer"></div>
        <div class="restricted-row">
          <div class="restricted-column">
            <div class="icon region-icons"><span class="fal fa-newspaper"></span></div>
            <h5 translate class="heading-4">About Edgeless</h5>
            <p translate>
              Edgeless is one of a few blockchain companies that has a product for mass consumer.
              <a
                href="https://edgelessgroup.io/?utm_source=casino&utm_medium=restricted-countries-registration"
                target="_blank"
                translate
                class="contact-us-link"
                rel="noopener"
                (click)="logEvent('Restricted Country Registration - Link to edgelessgroup')"
                >More info</a
              >
            </p>
          </div>
          <div class="restricted-column">
            <div class="icon region-icons"><span class="fal fa-chart-line"></span></div>
            <h5 translate class="heading-3">country_restriction.staking</h5>
            <p translate>
              country_restriction.staking_info<a
                href="https://staking.edgelessgroup.io/?utm_source=casino&utm_medium=restricted-countries-registration"
                target="_blank"
                translate
                class="contact-us-link"
                rel="noopener"
                (click)="logEvent('Restricted Country Registration - Link to staking')"
                >country_restriction.staking_more_info</a
              >
            </p>
          </div>
        </div>
        <div class="restricted-row">
          <div class="restricted-column">
            <div class="icon region-icons"><span class="fal fa-globe"></span></div>
            <h5 translate class="heading">country_restriction.bypass</h5>
            <p translate>country_restriction.bypass_info</p>
          </div>
          <div class="restricted-column">
            <div class="icon region-icons"><span class="fal fa-question"></span></div>
            <h5 class="heading-2" translate>country_restriction.need_help</h5>
            <p translate>
              Let's make this gambling experience the best in the industry!
              <a
                href="mailto:support@edgeless.io"
                translate
                class="contact-us-link"
                rel="noopener"
                (click)="logEvent('Restricted Country Registration - Email to support')"
                >support@edgeless.io</a
              >
            </p>
          </div>
        </div>
        <a href="#" (click)="close($event)" class="close-it"><i class="fa fa-times"></i></a>
        <div class="restricted-world-image" (click)="close($event)"></div>
      </div>
    </div>
  


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/country-restriction/country-registration-restriction.component.ts.CountryRegistrationRestrictionComponent.html